import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { cn } from "@/lib/utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TableHead',
    props: {
        class: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass(_unref(cn)('tw-pb-3 tw-px-4 tw-font-medium xl:tw-px-5 tw-text-left tw-align-middle [&:has([role=checkbox])]:tw-pr-0 [&:last-child]:tw-text-center rtl:tw-text-right', props.class))
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
